// aws-config.js
//
// Reads Cognito connection values from CRA environment variables.
// Set these in dcm-viewer/.env (copy the values from "cdk deploy" output).
//
// CRA exposes env variables prefixed with REACT_APP_ to the browser bundle.

import { Amplify } from 'aws-amplify';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
      identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
    },
  },
});
